document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('BespokeForm');
  if (!form) return;

  const fileInput = document.getElementById('BespokeForm-inspiration');
  const fileList = document.getElementById('BespokeForm-file-list');
  const submitButton = form.querySelector('button[type="submit"]');
  const MAX_TOTAL_BYTES = 10 * 1024 * 1024;
  const wrap = form.parentElement;

  function getRecipientEmail() {
    return (form.dataset.formsubmitEmail || '').trim();
  }

  function clearErrors() {
    const errorBox = wrap.querySelector('.custom-errors');
    if (errorBox) errorBox.remove();
  }

  function showErrors(messages) {
    clearErrors();
    const errorHtml = `
      <div class="form__message errors custom-errors" role="alert" tabindex="-1">
        <span class="svg-wrapper">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#DD0000" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.37258 0 0 5.3726 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"/>
          </svg>
        </span>
        <ul>
          ${messages.map((msg) => `<li>${msg}</li>`).join('')}
        </ul>
      </div>`;
    form.insertAdjacentHTML('beforebegin', errorHtml);
  }

  function showSuccess() {
    clearErrors();
    const existing = wrap.querySelector('.form-status');
    if (existing) existing.remove();

    form.insertAdjacentHTML(
      'beforebegin',
      '<p class="form-status form__message" tabindex="-1">Thanks for contacting us. We\'ll get back to you as soon as possible.</p>'
    );

    form.reset();
    if (fileList) fileList.innerHTML = '';

    // Clean success flag from URL without reload
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete('bespoke_sent');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  }

  function validateForm() {
    const requiredFields = form.querySelectorAll('[required]');
    const errorMessages = [];

    requiredFields.forEach((field) => {
      if (!field.value.trim()) {
        const label = field.placeholder || field.name;
        errorMessages.push(`Please complete the field: ${label}`);
      } else if (field.type === 'email' && !/^\S+@\S+\.\S+$/.test(field.value)) {
        errorMessages.push('Please enter a valid email address.');
      }
    });

    const files = fileInput ? Array.from(fileInput.files || []) : [];
    const totalBytes = files.reduce((sum, file) => sum + file.size, 0);
    if (totalBytes > MAX_TOTAL_BYTES) {
      errorMessages.push('Inspiration images must be under 10 MB total. Please upload fewer or smaller files.');
    }

    return errorMessages;
  }

  function ensureHidden(name, value) {
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function prepareNativeSubmit() {
    const recipient = getRecipientEmail();
    if (!recipient) {
      showErrors(['Form email is not configured. Please email concierge@shopclareza.com.']);
      return false;
    }

    const subjectField = form.querySelector('[name="subject"]');
    const subject = subjectField && subjectField.value.trim() ? subjectField.value.trim() : 'Bespoke inquiry';

    form.action = `https://formsubmit.co/${encodeURIComponent(recipient)}`;
    form.method = 'POST';
    form.enctype = 'multipart/form-data';

    // Native FormSubmit (not AJAX) — required for file attachments
    ensureHidden('_subject', `Bespoke inquiry: ${subject}`);
    ensureHidden('_template', 'table');
    ensureHidden('_captcha', 'false');
    ensureHidden('form', 'Bespoke inquiry');
    ensureHidden(
      '_next',
      `${window.location.origin}/pages/bespoke?bespoke_sent=1#BespokeForm`
    );

    return true;
  }

  // Returned from FormSubmit redirect
  const params = new URLSearchParams(window.location.search);
  if (params.get('bespoke_sent') === '1') {
    showSuccess();
    const anchor = document.getElementById('BespokeForm');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (fileInput && fileList) {
    fileInput.addEventListener('change', function () {
      fileList.innerHTML = '';
      Array.from(fileInput.files || []).forEach((file) => {
        const item = document.createElement('span');
        item.textContent = file.name;
        fileList.appendChild(item);
      });
    });
  }

  form.addEventListener(
    'submit',
    function (e) {
      clearErrors();
      const errorMessages = validateForm();
      if (errorMessages.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showErrors(errorMessages);
        return;
      }

      if (!prepareNativeSubmit()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      // Allow native multipart POST to FormSubmit (attachments work this way)
    },
    true
  );
});
